import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchAuditLogs, fetchAuditFilters, AuditLogQuery } from '../api/auditLogService';
import { useTenantCode } from './useTenantCode';

export const useAuditLogsQuery = (params: AuditLogQuery) => {
    const tenantCode = useTenantCode();
    return useQuery({
        queryKey: ['audit-logs', tenantCode, params],
        queryFn: () => fetchAuditLogs(params),
        placeholderData: keepPreviousData,
        staleTime: 30 * 1000,
    });
};

export const useAuditFiltersQuery = () => {
    const tenantCode = useTenantCode();
    return useQuery({
        queryKey: ['audit-logs', 'filters', tenantCode],
        queryFn: fetchAuditFilters,
        staleTime: 5 * 60 * 1000,
    });
};
